import Vue from "vue";
import _ from "lodash";

const warranty = {
  namespaced: true,
  state: {
    step: 1, // 质保卡注册信息填写步骤
    customerInfo: JSON.parse(localStorage.getItem("warranty_customerInfo") || "{}"), // 注册填写的客户的信息
    tireList: [],
    otherClaimInfo: {},
    propertyList: [] // 配置字段
  },
  getters: {
    propertyShowList: state => {
      // 显隐
      return state.propertyList.filter(o => !o.hide).map(o => o.key);
    },
    propertyNoRequiredList: state => {
      // 非必填
      return state.propertyList.filter(o => !o.required).map(o => o.key);
    }
  },
  mutations: {
    initTireList(state, num) {
      state.tireList = Array.from({ length: num }, () =>
        _.cloneDeep({
          tireNo: "",
          price: "",
          brand: "Giti",
          size: {
            tread: "",
            treadIndex: -2,
            aspect: "",
            aspectIndex: -2,
            rim: "",
            rimIndex: -2
          },
          pattern: ""
        })
      );
    },
    updateTireList(state, { index, newItem }) {
      Vue.set(state.tireList, index, newItem);
    },
    addTireList(state, newItem) {
      state.tireList.push(newItem);
    },
    deleteTireList(state, idx) {
      state.tireList.splice(idx, 1);
    },
    setStep(state, val = 1) {
      state.step = val;
    },
    setCustomerInfo(state, data = {}) {
      if (Object.keys(data).length !== 0) {
        state.customerInfo = data;
        localStorage.setItem("warranty_customerInfo", JSON.stringify(data));
      } else {
        state.customerInfo = {};
        localStorage.removeItem("warranty_customerInfo");
      }
    },
    setPropertyList(state, data = []) {
      state.propertyList = data;
    },
    setOtherClaimInfo(state, data) {
      const info = state.otherClaimInfo;
      const obj = {};
      Object.assign(obj, info, data);
      state.otherClaimInfo = obj;
    },
    cleanOtherClaimInfo(state, data) {
      state.otherClaimInfo = {};
    }
  },
  actions: {
    // 创建质保卡
    async create({ rootState, commit }, params = {}) {
      const data = await rootState.http("/warranty/card/create", params);
      return data;
    },
    // 查询轮胎参数大小
    async queryTireSize({ rootState, commit }, params = {}) {
      const data = await rootState.http("/warranty/card/queryTireSize", params);
      return data;
    },
    // 查询轮胎花纹
    async queryTireTreadPattern({ rootState, commit }, params = {}) {
      const data = await rootState.http("/warranty/card/queryTireTreadPattern", params);
      return data;
    },
    // 查询质保卡列表
    async queryList({ rootState, commit }, params = {}) {
      const data = await rootState.http("/warranty/card/queryList ", params);
      return data;
    },
    // 查询质保卡明细
    async detail({ rootState, commit }, params = {}) {
      const data = await rootState.http("/warranty/card/detail", params);
      return data;
    },
    // 质保理赔
    async claim({ rootState, commit }, params = {}) {
      const data = await rootState.http("/warranty/card/claimApply", params);
      return data;
    },
    // 根据胎号查询花纹、size
    async searchTire({ rootState, commit }, params = {}) {
      const data = await rootState.http("/warranty/tire/searchTire", params);
      return data;
    },
    // 质保卡配置字段信息
    async propertiesConfig({ rootState, commit }, params = {}) {
      const { data = [] } = await rootState.http("/warranty/card/propertiesConfig", params);
      commit("setPropertyList", data);
      const { minSize = 1 } = data.find(o => o.key === "items") || {};
      commit("initTireList", minSize);
    },
    // 查询理赔申请列表
    async queryClaimApplyList({ rootState, commit }, params = {}) {
      const data = await rootState.http("/warranty/card/queryApplyList", params);
      return data;
    },
    // 查询理赔申请列表
    async uploadPurchaseReceipt({ rootState, commit }, params = {}) {
      const data = await rootState.http("/warranty/card/uploadPurchaseReceipt", params);
      return data;
    },
    async queryOtherWarrantyClaimApplyWarrantyContent({ rootState, commit }, params = {}) {
      const data = await rootState.http("/warranty/card/queryOtherWarrantyClaimApplyWarrantyContent", params);
      return data;
    },
    async checkNoWarrantyCardClaimEligibility({ rootState, commit }, params = {}) {
      const data = await rootState.http("/warranty/card/checkNoWarrantyCardClaimEligibility", params);
      return data;
    },
    async saveOtherWarrantyClaimApply({ rootState, commit }, params = {}) {
      const data = await rootState.http("/warranty/card/otherWarrantyClaimApply", params);
      return data;
    }
  }
};

export default warranty;



// WEBPACK FOOTER //
// ./src/store/modules/warranty.js